// extracted by mini-css-extract-plugin
export var sbShowMain = "link-module--sb-show-main--BK4Fo";
export var specialColorLink = "link-module--specialColorLink--fcDp2";